import React from "react";
import { Stack, Typography } from "@mui/material";

import { ReactComponent as SearchNotFoundIcon } from "@/ui/assets/vectors/search_not_found.svg";

export const EmptyContent = ({
  title = "No results found",
  message = "We could not find any results that match your search. Try again by adjusting the search criteria.",
  children,
  iconComponent,
  size,
  slotProps,
}: {
  title?: string;
  message?: React.ReactNode;
  children?: React.ReactNode;
  iconComponent?: React.ReactNode;
  size?: "small";
  slotProps?: {
    rootStack?: React.ComponentProps<typeof Stack>;
    title?: React.ComponentProps<typeof Typography>;
    message?: Omit<React.ComponentProps<typeof Typography>, "ref">;
  };
}) => {
  return (
    <Stack
      height="100%"
      width="100%"
      alignItems="center"
      justifyContent="center"
      gap={1}
      textAlign="center"
      {...slotProps?.rootStack}
    >
      {iconComponent || (
        <SearchNotFoundIcon
          width={size === "small" ? 60 : 80}
          height={size === "small" ? 60 : 80}
        />
      )}
      {title && (
        <Typography
          variant={size === "small" ? undefined : "h5"}
          fontWeight={size === "small" ? 500 : undefined}
          color="text.primary"
          {...slotProps?.title}
        >
          {title}
        </Typography>
      )}
      {message && (
        <Typography
          mb={1}
          variant={size === "small" ? "body2" : "body1"}
          color="text.secondary"
          maxWidth={600}
          component="div"
          {...slotProps?.message}
        >
          {message}
        </Typography>
      )}
      {children}
    </Stack>
  );
};

export default EmptyContent;
